var _dec, _class;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @module AppTree */
import React from "react";
import ReactDOM from "react-dom";
import { DashIcon } from "./";
import renderOrderMenu from "../others/renderOrderMenu";
import renderSortMenu, { RearrangeBox } from "../others/renderSortMenu";
import AIOTree, { getTreeParentById, getRecursivelyCheckedNodes, immer } from "react-aiot";
import { message, Icon, Popconfirm, Alert } from "react-aiot";
import { hooks, rmlOpts, i18n, urlParam, addUrlParam, isMaterialWp, materialWpResizeOpposite, ICON_OBJ_FOLDER_CLOSED, ICON_OBJ_FOLDER_OPEN, ICON_OBJ_FOLDER_COLLECTION, ICON_OBJ_FOLDER_GALLERY, resolveIcon, request } from "../util";
import { draggable, droppable } from "../util/dragdrop";
import $ from "jquery";
import { FILTER_SELECTOR } from "../others/filter";
import createLockedToolTipText from "../hooks/permissions";
import { inject, observer, Observer } from "mobx-react";
import { toggleSortable, orderUrl } from "../hooks/sortable";
import MetaBox from "../components/MetaBox";
import { getDefaultFolder, ID_NONE } from "../others/defaultFolder";
import { ProFooter, ProBox } from "../components/ProFooter";
import { isRatable, RatingPointer } from "@devowl-wp/real-utils";
/**
 * The latest queried folder.
 *
 * @deprecated Do no longer use it, use rmlOpts.others.lastQueried instead
 * @type object
 */

export let latestQueriedFolder = {
  node: null
};
message.config({
  top: 50
});
/**
 * The application tree handler for Real Media Library.
 *
 * @param {string} id The HTML id (needed to localStorage support)
 * @param {object} [attachmentsBrowser] The attachments browser (for media grid view)
 * @param {boolean} [isModal=false] If true the given app tree is a modal dialog
 * @param {module:AppTree~AppTree~init} [init]
 * @see module:store.StoredAppTree
 * @see module:react-aiot~Tree
 * @extends React.Component
 */

let AppTree = (_dec = inject("store"), _dec(_class = observer(_class = class AppTree extends React.Component {
  /**
   * Initialize properties and state for AIOTree component.
   * Also handles the responsiveness.
   */
  constructor(_props) {
    super(_props); // Add respnsive handler for non-modal views

    this.renderToolbarButtons = multi => {
      let availableToolbarButtons = multi ? this.state.availableMultiToolbarButtons : this.state.availableToolbarButtons,
          {
        toolbarBackButton
      } = this.state;
      const toolbar = {
        buttons: {},
        backButton: this.resolveStateRefs(toolbarBackButton, "keysToolbar")
      };

      for (let i = 0; i < availableToolbarButtons.length; i++) {
        toolbar.buttons[availableToolbarButtons[i]] = this.resolveStateRefs(this.state[(multi ? "multiToolbar_" : "toolbar_") + availableToolbarButtons[i]], "keysToolbar");
      }

      return toolbar;
    };

    this.renderCreatables = () => {
      const {
        availableCreatables,
        creatableBackButton
      } = this.state,
            creatable = {
        buttons: {},
        backButton: this.resolveStateRefs(creatableBackButton, "keysCreatable")
      };

      for (let i = 0; i < availableCreatables.length; i++) {
        creatable.buttons[availableCreatables[i]] = this.resolveStateRefs(this.state["creatable_" + availableCreatables[i]], "keysCreatable");
      }

      return creatable;
    };

    this.doRef = ref => this.ref = ref;

    this.handleCloseMultiToolbar = checkedNodes => {
      checkedNodes.forEach(n => n.toggleChecked(false, false));
    };

    this.handleCreatableClick = (type, typeInt) => {
      this._lastHandleCreatableClickArgs = [type, typeInt]; // @see handleAddClose

      let createRoot = undefined,
          $create = undefined;

      if (type) {
        // Activate create
        const creatable = this.state["creatable_" + type],
              newNode = {
          $rename: true,
          icon: this.resolveStateRef(creatable.icon),
          iconActive: this.resolveStateRef(creatable.iconActive),
          parent: +rmlOpts.others.rootId,
          typeInt
        },
              selectedId = this.getSelectedId();

        if (typeof selectedId !== "number" || [+rmlOpts.others.rootId, ID_NONE].indexOf(selectedId) > -1) {
          createRoot = newNode;
        } else {
          $create = newNode;
          newNode.parent = selectedId;
        }
      }

      this.setState({
        isTreeLinkDisabled: !!type,
        isCreatableLinkCancel: !!type,
        isToolbarActive: !type,
        createRoot
      });
      this.updateTreeItemById(node => {
        node.$create = $create;
      });
    };

    this.handleDelayedDroppable = () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => droppable(this), 200);
    };

    this.handleCheck = id => {
      this.props.store.getTreeItemById(id).toggleChecked();
    };

    this.handleSelect = id => {
      // Do nothing when sort mode is active
      if (this.state.toolbarActiveButton === "sort") {
        return;
      }

      const select = this.getTreeItemById(id, false),
            setter = (_id, $busy) => {
        latestQueriedFolder.node = select;
        latestQueriedFolder.node.setter(node => {
          node.$busy = $busy;
          node.selected = true;
        });
        rmlOpts.others.lastQueried = select.id;
        /**
         * The user is selecting a node in the app tree.
         *
         * @event module:util/hooks#tree/select
         * @param {int|string} id
         * @param {object} select The MST node
         * @param {object} attachmentsBrowser
         * @this module:AppTree~AppTree
         * @since 4.0.5
         */

        hooks.call("tree/select", [_id, select, this.attachmentsBrowser], this);
      };

      if (this.attachmentsBrowser) {
        !id && this.attachmentsBrowser.collection.props.set({
          ignore: +new Date()
        }); // Reload the view

        this._handleBackboneFilterSelection(select.id);
      } else {
        const keepParams = [{
          param: "page",
          value: urlParam("page")
        }, {
          param: "paged",
          value: urlParam("paged") !== null ? 1 : null
        }].filter(({
          value
        }) => value !== null);
        let href = window.location.href;
        urlParam("orderby") === "rml" && (href = href.split("?")[0]);

        for (const {
          param,
          value
        } of keepParams) {
          href = addUrlParam(href, param, value);
        }

        select.properties && (select.contentCustomOrder === 1 || select.forceCustomOrder) && (href = orderUrl(href));
        window.location.href = addUrlParam(href, "rml_folder", select.id);
      }

      setter(select.id, !this.attachmentsBrowser);
    };

    this.handleResize = () => {
      var _attachmentsBrowser$a;

      const {
        attachmentsBrowser
      } = this;
      attachmentsBrowser === null || attachmentsBrowser === void 0 ? void 0 : (_attachmentsBrowser$a = attachmentsBrowser.attachments) === null || _attachmentsBrowser$a === void 0 ? void 0 : _attachmentsBrowser$a.setColumns();
    };

    this.handleOrderClick = () => {
      if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
        this.setState({
          showProFeature: "order-content"
        });
      } else {
        if (toggleSortable(this.getTreeItemById(), true, this.attachmentsBrowser)) {
          this.setState({
            isMoveable: false,
            toolbarActiveButton: "order",
            toolbarBackButton: Object.assign(this.state.toolbarBackButton, {
              label: "i18n.back"
            })
          });
        }
      }
    };

    this.handleOrderCancel = () => {
      toggleSortable(this.getTreeItemById(), false, this.attachmentsBrowser);
      this.setState({
        isMoveable: true,
        toolbarActiveButton: undefined,
        toolbarBackButton: Object.assign(this.state.toolbarBackButton, {
          label: "i18n.cancel"
        })
      });
    };

    this.handleRenameClick = () => this._handleRenameNode("rename", true, true, true);

    this.handleRenameCancel = () => this._handleRenameNode(undefined, false, false, undefined);

    this.handleRenameClose = async (save, inputValue, {
      id,
      title
    }) => {
      if (save && inputValue.length && title !== inputValue) {
        const hide = message.loading(i18n("renameLoadingText", {
          name: inputValue
        }));

        try {
          const node = this.props.store.getTreeItemById(id),
                {
            name
          } = await node.setName(inputValue);
          /**
           * Folder successfully renamed.
           *
           * @event module:util/hooks#folder/renamed
           * @param {module:store/TreeNode~TreeNode} node The node
           * @this module:AppTree~AppTree
           * @since 4.0.7
           */

          hooks.call("folder/renamed", [node], this);
          message.success(i18n("renameSuccess", {
            name
          }));
          this.handleRenameCancel();
        } catch (e) {
          message.error(e.responseJSON.message);
        } finally {
          hide();
        }
      } else {
        this.handleRenameCancel();
      }
    };

    this.handleAddClose = async (save, name, {
      parent,
      typeInt
    }) => {
      if (save) {
        if (process.env.PLUGIN_CTX === "lite" && parent !== this.props.store.rootId) {
          this.setState({
            showProFeature: "subfolder"
          });
          return;
        }

        this.updateCreateNode(obj => {
          obj.$busy = true;
        });
        const hide = message.loading(i18n("addLoadingText", {
          name
        })),
              ctrlHolding = $("body").hasClass("aiot-helper-ctrl");

        try {
          const newObj = await this.props.store.persist(name, {
            parent,
            typeInt
          }, () => {
            if (ctrlHolding) {
              // Allow bulk insert while holding ctrl + enter
              this.handleCreatableClick(...this._lastHandleCreatableClickArgs);
            } else {
              this.handleCreatableClick();
            }
          }); // Show rating pointer

          isRatable(rmlOpts.slug) && this.ref && new RatingPointer(rmlOpts.slug, $(this.ref.container).find(".aiot-tree-headline"));
          message.success(i18n("addSuccess", {
            name
          })); // Modify all available attachments browsers filter

          let backboneFilter, lastSlugs;
          $(FILTER_SELECTOR).each(function () {
            backboneFilter = $(this).data("backboneView");

            if (backboneFilter) {
              lastSlugs = backboneFilter.lastSlugs;
              lastSlugs.names.push("(NEW) " + name);
              lastSlugs.slugs.push(newObj.id);
              lastSlugs.types.push(typeInt);
              backboneFilter.createFilters(lastSlugs);
            }
          });
          !ctrlHolding && droppable(this);
        } catch (e) {
          message.error(e.responseJSON.message);
          this.updateCreateNode(obj => {
            obj.$busy = false;
          });
        } finally {
          hide();
        }
      } else {
        this.handleCreatableClick();
      }
    };

    this.handleTrash = async (e, node = this.getTreeItemById(), isMulti) => {
      // Check if subdirectories
      if (node.childNodes.filter(node => node.$visible).length) {
        message.error(i18n("deleteFailedSub", {
          name: node.title
        }));
        return false;
      }

      const hide = message.loading(i18n("deleteLoadingText", {
        name: node.title
      }));

      try {
        await node.trash();
        !isMulti && message.success(i18n("deleteSuccess", {
          name: node.title
        }));
        /**
         * A folder has been deleted.
         *
         * @event module:util/hooks#tree/select
         * @param {module:store/TreeNode~TreeNode} node The node
         * @param {object} attachmentsBrowser
         * @this module:AppTree~AppTree
         * @since 4.0.7
         */

        hooks.call("folder/deleted", [node, this.attachmentsBrowser], this); // Select parent

        if (!isMulti) {
          const parentId = getTreeParentById(node.id, this.props.store.tree);
          this.handleSelect(parentId === 0 ? +rmlOpts.others.rootId : parentId);
        }

        return true;
      } catch (e) {
        message.error(e.responseJSON.message);
        return false;
      } finally {
        hide();
      }
    };

    this.handleMultipleTrash = async () => {
      let count = 0;
      this.setState({
        isTreeBusy: true
      });
      const checkedNodes = getRecursivelyCheckedNodes(this.props.store.tree, true);
      this.handleSelect(+rmlOpts.others.rootId);

      for (const nodes of Object.values(checkedNodes).reverse()) {
        for (const node of nodes) {
          count++;
          const result = await this.handleTrash(null, node, true); // An error occured, break the loop...

          if (!result) {
            this.setState({
              isTreeBusy: false
            });
            return;
          }
        }
      }

      message.success(i18n("deleteMultipleSuccess", {
        count
      }));
      this.setState({
        isTreeBusy: false
      });
    };

    this.handleSortManual = async (...args) => {
      if (process.env.PLUGIN_CTX === "lite" && args.parentToId !== this.props.store.rootId && args.parentToId !== undefined) {
        this.setState({
          showProFeature: "subfolder"
        });
        return false;
      }

      const result = await this.handleSort(...args);
      result && this.setState({
        rearrangeBoxId: false,
        isSortableBusy: false,
        isToolbarBusy: false
      });
      return result;
    };

    this.handleSort = async ({
      doFinally = true,
      ...props
    }) => {
      const {
        store
      } = this.props;

      if (process.env.PLUGIN_CTX === "lite" && props.parentToId !== store.rootId) {
        // Revert changes in UI (first move, afterwards cancel to update the observable correctly)
        store.handleSort({ ...props,
          request: false
        });
        store.handleSort({
          id: props.id,
          oldIndex: props.newIndex,
          newIndex: props.oldIndex,
          parentFromId: props.parentToId,
          parentToId: props.parentFromId,
          request: false
        });
        this.setState({
          showProFeature: "subfolder"
        });
        return false;
      }

      this.setState({
        isSortableBusy: true,
        isToolbarBusy: true
      });
      const hide = message.loading(i18n("sortLoadingText")),
            {
        toolbarActiveButton
      } = this.state,
            {
        parentFromId,
        parentToId
      } = props;

      try {
        await store.handleSort(props);
        message.success(i18n("sortedSuccess"));

        if (parentFromId === parentToId) {
          /**
           * This action is called when a folder was relocated in the
           * folder tree. That means the parent was not changed, only
           * the order was changed.
           *
           * @event module:util/hooks#folder/relocated
           * @param {object} props The move properties
           * @this module:AppTree~AppTree
           * @since 4.0.7
           */
          hooks.call("folder/relocated", [props], this);
        } else {
          /**
           * This action is called when a folder was moved in the folder tree.
           * That means the parent and order was changed.
           *
           * @event module:util/hooks#folder/moved
           * @param {object} props The move properties
           * @this module:AppTree~AppTree
           * @since 4.0.7
           */
          hooks.call("folder/moved", [props], this);
        }

        return true;
      } catch (e) {
        message.error(e.responseJSON.message);
        return false;
      } finally {
        hide();
        doFinally && this._handleSortNode(toolbarActiveButton, false);
      }
    };

    this.handleWindowResize = () => {
      const isMobile = this._isMobile();

      this.setState({
        isSticky: !isMobile,
        isStickyHeader: !isMobile,
        isResizable: !isMobile,
        isFullWidth: isMobile,
        style: isMobile ? {
          marginLeft: 10
        } : {}
      });
    };

    this.handleReload = () => {
      this.handleSelect();
    };

    this.handleDismissImportTaxNotice = async () => {
      await request({
        location: {
          path: "/notice/import",
          method: "DELETE"
        }
      });
      window.location.reload();
    };

    this.onTreeNodeRender = (createTreeNode, TreeNode, node) => {
      return /*#__PURE__*/React.createElement(Observer, {
        key: node.id
      }, () => createTreeNode(node, {
        indeterminate: node.indeterminate
      }));
    };

    this.onTreeNodeRenderIcon = icon => resolveIcon(icon);

    this._handleRenameNode = (toolbarActiveButton, isCreatableLinkDisabled, isTreeLinkDisabled, nodeRename) => {
      this.setState({
        // Make other nodes editable / not editable
        isCreatableLinkDisabled,
        isTreeLinkDisabled,
        toolbarActiveButton
      });
      this.updateTreeItemById(node => {
        // Make selected node editable / not editable
        node.$rename = nodeRename;
      });
    };

    this._isMobile = () => $(window).width() <= 700;

    this._handleSortNode = (toolbarActiveButton, isBusy) => {
      this.setState({
        isCreatableLinkDisabled: !!toolbarActiveButton,
        toolbarActiveButton,
        isSortableDisabled: !toolbarActiveButton,
        toolbarBackButton: Object.assign(this.state.toolbarBackButton, {
          label: "i18n." + (toolbarActiveButton ? "back" : "cancel")
        })
      });
      typeof isBusy === "boolean" && this.setState({
        isSortableBusy: isBusy
      });
      typeof isBusy === "boolean" && this.setState({
        isToolbarBusy: isBusy
      });
    };

    this._handleDetails = (action, status, response) => {
      const metaBoxId = action ? action === "usersettings" ? action : this.props.store.selectedId : false;
      this.setState({
        metaBoxId
      }); // When the metadata is saved successfully listen to the "reload" state and reload the current view.

      if (status === true && response) {
        const {
          reload,
          hardReloadIfBodyHasClass
        } = response;

        if (reload) {
          this.handleReload();
        } else if (hardReloadIfBodyHasClass && $("body").hasClass(hardReloadIfBodyHasClass)) {
          window.location.reload();
        }
      }
    };

    !_props.isModal && $(window).resize(this.handleWindowResize);

    const _isMobile = this._isMobile(); // State refs (see https://github.com/reactjs/redux/issues/1793) and #resolveStateRefs


    this.stateRefs = {
      keysCreatable: "icon,iconActive,toolTipTitle,toolTipText,onClick,label".split(","),
      keysToolbar: "content,toolTipTitle,toolTipText,onClick,onCancel,onSave,modifier,label,save,menu".split(","),
      // Icons
      ICON_OBJ_FOLDER_CLOSED,
      ICON_OBJ_FOLDER_OPEN,
      ICON_OBJ_FOLDER_COLLECTION,
      ICON_OBJ_FOLDER_GALLERY,
      ICON_SETTINGS: /*#__PURE__*/React.createElement(Icon, {
        type: "setting"
      }),
      ICON_LOCKED: /*#__PURE__*/React.createElement(Icon, {
        type: "lock"
      }),
      ICON_ORDER: /*#__PURE__*/React.createElement(DashIcon, {
        name: "move"
      }),
      ICON_RELOAD: /*#__PURE__*/React.createElement(Icon, {
        type: "reload"
      }),
      ICON_RENAME: /*#__PURE__*/React.createElement(Icon, {
        type: "edit"
      }),
      ICON_TRASH: /*#__PURE__*/React.createElement(Icon, {
        type: "delete"
      }),
      ICON_SORT: /*#__PURE__*/React.createElement(DashIcon, {
        name: "sort"
      }),
      ICON_SAVE: /*#__PURE__*/React.createElement(Icon, {
        type: "save"
      }),
      ICON_ELLIPSIS: /*#__PURE__*/React.createElement(Icon, {
        type: "ellipsis"
      }),
      // Creatable
      handleCreatableClickBackButton: () => this.handleCreatableClick(),
      handleCreatableClickFolder: () => this.handleCreatableClick("folder", 0),
      handleCreatableClickCollection: rmlOpts.others.isPro ? () => this.handleCreatableClick("collection", 1) : () => this.setState({
        showProFeature: "collections"
      }),
      handleCreatableClickGallery: () => this.handleCreatableClick("gallery", 2),
      // Toolbar buttons
      renderOrderMenu: renderOrderMenu.bind(this),
      renderSortMenu: renderSortMenu.bind(this),
      handleOrderClick: this.handleOrderClick,
      handleOrderCancel: this.handleOrderCancel,
      handleReload: this.handleReload,
      handleRenameClick: this.handleRenameClick,
      handleRenameCancel: this.handleRenameCancel,
      handleTrashModifier: body => {
        const node = this.getTreeItemById();
        return node ? /*#__PURE__*/React.createElement(Popconfirm, {
          placement: "bottom",
          onConfirm: this.handleTrash,
          title: i18n("deleteConfirm", {
            name: node.title
          }, "maxWidth"),
          okText: i18n("ok"),
          cancelText: i18n("cancel")
        }, body) : body;
      },
      handleMultipleTrashModifier: body => {
        const checkedNodes = getRecursivelyCheckedNodes(this.props.store.tree);
        return /*#__PURE__*/React.createElement(Popconfirm, {
          placement: "bottom",
          onConfirm: this.handleMultipleTrash,
          title: i18n("deleteMultipleConfirm", {
            count: checkedNodes.length
          }, "maxWidth"),
          okText: i18n("ok"),
          cancelText: i18n("cancel")
        }, body);
      },
      handleSortClick: () => this._handleSortNode("sort"),
      handleSortCancel: () => this._handleSortNode(),
      handleDetailsClick: () => this._handleDetails("details"),
      handleUserSettingsClick: () => this._handleDetails("usersettings")
    }; // Determine selected id and fetch tree

    let _selectedId = getDefaultFolder();

    this.attachmentsBrowser = _props.attachmentsBrowser;
    this.state = {
      // Custom
      currentFolderRestrictions: [],
      isModal: _props.isModal,
      isMoveable: true,
      isWPAttachmentsSortMode: false,
      // See modal.js
      initialSelectedId: !_selectedId || _selectedId === "all" ? "all" : +_selectedId,
      metaBoxId: false,
      rearrangeBoxId: false,
      showProFeature: undefined,
      // Creatables
      availableCreatables: (rmlOpts.others.isPro || rmlOpts.others.showProHints ? "folder,collection,gallery" : "folder").split(","),
      selectedCreatableType: undefined,
      // The selected folder type
      creatable_folder: {
        icon: "ICON_OBJ_FOLDER_CLOSED",
        iconActive: "ICON_OBJ_FOLDER_OPEN",
        visibleInFolderType: [undefined, 0],
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable0ToolTipTitle",
        toolTipText: "i18n.creatable0ToolTipText",
        label: "+",
        onClick: "handleCreatableClickFolder"
      },
      creatable_collection: {
        icon: "ICON_OBJ_FOLDER_COLLECTION",
        visibleInFolderType: [undefined, 0, 1],
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable1ToolTipTitle",
        toolTipText: "i18n.creatable1ToolTipText",
        label: "+",
        onClick: "handleCreatableClickCollection"
      },
      creatable_gallery: {
        icon: "ICON_OBJ_FOLDER_GALLERY",
        visibleInFolderType: [1],
        visible: false,
        cssClasses: "page-title-action add-new-h2",
        toolTipTitle: "i18n.creatable2ToolTipTitle",
        toolTipText: "i18n.creatable2ToolTipText",
        label: "+",
        onClick: "handleCreatableClickGallery"
      },
      creatableBackButton: {
        cssClasses: "page-title-action add-new-h2",
        label: "i18n.cancel",
        onClick: "handleCreatableClickBackButton"
      },
      // Toolbar buttons
      availableToolbarButtons: (rmlOpts.others.isPro || rmlOpts.others.showProHints ? "locked,usersettings,order,reload,rename,trash,sort,details" : "locked,usersettings,reload,rename,trash,sort,details").split(","),
      toolbar_usersettings: {
        content: "ICON_SETTINGS",
        visible: !!+rmlOpts.others.userSettings,
        toolTipTitle: "i18n.userSettingsToolTipTitle",
        toolTipText: "i18n.userSettingsToolTipText",
        onClick: "handleUserSettingsClick"
      },
      toolbar_locked: {
        content: "ICON_LOCKED",
        visible: false,
        toolTipTitle: "i18n.lockedToolTipTitle",
        toolTipText: "" // Lazy

      },
      toolbar_order: {
        content: "ICON_ORDER",
        toolTipTitle: "i18n.orderToolTipTitle",
        toolTipText: "i18n.orderToolTipText",
        onClick: "handleOrderClick",
        onCancel: "handleOrderCancel",
        menu: "resolve.renderOrderMenu",
        toolTipPlacement: "topLeft",
        dropdownPlacement: "bottomLeft"
      },
      toolbar_reload: {
        content: "ICON_RELOAD",
        toolTipTitle: "i18n.refreshToolTipTitle",
        toolTipText: "i18n.refreshToolTipText",
        onClick: "handleReload"
      },
      toolbar_rename: {
        content: "ICON_RENAME",
        toolTipTitle: "i18n.renameToolTipTitle",
        toolTipText: "i18n.renameToolTipText",
        onClick: "handleRenameClick",
        onCancel: "handleRenameCancel",
        disabled: true
      },
      toolbar_trash: {
        content: "ICON_TRASH",
        toolTipTitle: "i18n.trashToolTipTitle",
        toolTipText: "i18n.trashToolTipText",
        modifier: "handleTrashModifier",
        disabled: true
      },
      toolbar_sort: {
        content: "ICON_SORT",
        toolTipTitle: "i18n.sortToolTipTitle",
        toolTipText: "i18n.sortToolTipText",
        onClick: "handleSortClick",
        onCancel: "handleSortCancel",
        menu: "resolve.renderSortMenu",
        toolTipPlacement: "topLeft",
        dropdownPlacement: "bottomLeft"
      },
      toolbar_details: {
        content: "ICON_ELLIPSIS",
        disabled: true,
        toolTipTitle: "i18n.detailsToolTipTitle",
        toolTipText: "i18n.detailsToolTipText",
        onClick: "handleDetailsClick"
      },
      toolbarBackButton: {
        label: "i18n.cancel",
        save: "i18n.save"
      },
      // Multitoolbar buttons
      availableMultiToolbarButtons: "trash".split(","),
      multiToolbar_trash: {
        content: "ICON_TRASH",
        toolTipTitle: "i18n.trashToolTipTitle",
        toolTipText: "i18n.trashMultipleToolTipText",
        modifier: "handleMultipleTrashModifier"
      },
      // AIO
      isResizable: !_isMobile,
      isSticky: !_isMobile,
      isStickyHeader: !_isMobile,
      isFullWidth: _isMobile,
      style: _isMobile ? {
        marginLeft: 10
      } : {},
      isSortable: true,
      isSortableDisabled: true,
      isTreeBusy: false,
      isBusyHeader: false,
      headerStickyAttr: {
        top: "#wpadminbar"
      },
      isCreatableLinkDisabled: false,
      toolbarActiveButton: undefined,
      isTreeLinkDisabled: false,
      onResizeOpposite: isMaterialWp() && materialWpResizeOpposite
    }; // What happens if the attachments browser is available? We will add a reference to this React element

    this.attachmentsBrowser && (this.attachmentsBrowser.controller.$RmlAppTree = this);
    /**
     * Called on initialzation and allows you to modify the init state.
     *
     * @callback module:AppTree~AppTree~init
     * @param {object} state The default state
     * @param {AppTree} tree The AppTree component instance
     * @returns {object} The new state
     */

    _props.init && (this.state = _props.init(this.state, this));
    /**
     * The React AppTree instance gets constructed and you can modify it here.
     *
     * @event module:util/hooks#tree/init
     * @param {object} state
     * @param {object} props
     * @this module:AppTree~AppTree
     */

    hooks.call("tree/init", [this.state, _props], this);
    this.initialSelectedId = this.state.initialSelectedId;
  }
  /**
   * Render AIO tree with tax switcher.
   */


  render() {
    //{ metaBoxId !== false && (<MetaBox treeInstance={ this } patcher={ patcher => (this.metaboxPatcher = patcher) }
    // busy={ isBusyHeader } errors={ metaBoxErrors } id={ metaBoxId } />) }
    const {
      staticTree,
      tree
    } = this.props.store,
          {
      metaBoxId,
      rearrangeBoxId,
      showProFeature
    } = this.state;
    return /*#__PURE__*/React.createElement(AIOTree, _extends({
      ref: this.doRef,
      id: this.props.id,
      rootId: +rmlOpts.others.rootId,
      staticTree: staticTree,
      tree: tree.length > 0 ? tree : [],
      opposite: document.getElementById("wpbody-content"),
      onSelect: this.handleSelect,
      onCloseMultiToolbar: this.handleCloseMultiToolbar,
      onRenameClose: this.handleRenameClose,
      onAddClose: this.handleAddClose,
      onCheck: this.handleCheck,
      onNodeExpand: this.handleDelayedDroppable,
      onSearchResult: this.handleDelayedDroppable,
      renderItem: this.onTreeNodeRender,
      renderIcon: this.onTreeNodeRenderIcon,
      onNodePressF2: this.handleRenameClick,
      onSort: this.handleSort,
      onResize: this.handleResize,
      headline: /*#__PURE__*/React.createElement("span", {
        style: {
          paddingRight: 5
        }
      }, i18n("folders")),
      renameSaveText: this.stateRefs.ICON_SAVE,
      renameAddText: this.stateRefs.ICON_SAVE,
      noFoldersTitle: i18n("noFoldersTitle"),
      noFoldersDescription: i18n("noFoldersDescription"),
      noSearchResult: i18n("noSearchResult"),
      innerClassName: "wrap",
      theme: "wordpress",
      creatable: this.renderCreatables(),
      toolbar: this.renderToolbarButtons(),
      multiToolbar: this.renderToolbarButtons(true),
      forceSortableFallback: true,
      allowMultiSelect: true
    }, this.state, {
      // Sortable
      sortableDelay: this.state.isSortableDisabled ? 150 : 0,
      isSortableDisabled: false
    }), rmlOpts.others.isDevLicense && /*#__PURE__*/React.createElement(Alert, {
      message: /*#__PURE__*/React.createElement(React.Fragment, null, i18n("licenseIsDev"), " (", /*#__PURE__*/React.createElement("a", {
        href: rmlOpts.others.lang.devLicenseLink,
        rel: "noreferrer",
        target: "_blank"
      }, i18n("devLicenseLearnMore")), ")"),
      type: "warning",
      style: {
        marginBottom: "10px"
      }
    }), rmlOpts.others.showTaxImportNotice && /*#__PURE__*/React.createElement(Alert, {
      message: /*#__PURE__*/React.createElement("span", null, rmlOpts.others.lang.sidebarDetectedTax, " ", /*#__PURE__*/React.createElement("a", {
        href: rmlOpts.others.taxImportNoticeLink
      }, rmlOpts.others.lang.sidebarDetectedTaxImport), " ", "\xB7", " ", /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.handleDismissImportTaxNotice
      }, rmlOpts.others.lang.sidebarDetectedTaxDismiss)),
      type: "info",
      style: {
        marginBottom: "10px"
      }
    }), !rmlOpts.others.isPro && rmlOpts.others.showProHints && rmlOpts.others.showLiteNotice && /*#__PURE__*/React.createElement(ProFooter, {
      dismissible: true,
      feature: "sidebar"
    }), /*#__PURE__*/React.createElement(ProBox, {
      feature: showProFeature,
      onClose: () => this.setState({
        showProFeature: undefined
      })
    }), /*#__PURE__*/React.createElement(MetaBox, {
      id: metaBoxId,
      onClose: (status, response) => this._handleDetails(undefined, status, response)
    }), /*#__PURE__*/React.createElement(RearrangeBox, {
      id: rearrangeBoxId,
      onClose: () => this.setState({
        rearrangeBoxId: undefined
      }),
      onSort: this.handleSortManual
    }));
  }
  /**
   * @returns {object}
   */


  /**
   * Iterates all available values in an object and resolve it with the available
   * this::stateRefs.
   *
   * @returns {object}
   */
  resolveStateRefs(_obj, keys) {
    const obj = Object.assign({}, _obj);
    let value, newValue;

    for (let key in obj) {
      if ( // eslint-disable-next-line no-prototype-builtins
      obj.hasOwnProperty(key) && (value = obj[key]) && this.stateRefs[keys].indexOf(key) > -1 && typeof value === "string" && (newValue = this.resolveStateRef(value))) {
        obj[key] = newValue;
      }
    }

    return obj;
  }
  /**
   * Resolve single state ref key.
   *
   * @returns {object}
   */


  resolveStateRef(key) {
    if (typeof key !== "string") {
      return;
    }

    if (key.indexOf("i18n.") === 0) {
      return i18n(key.substr(5));
    } else if (key.indexOf("resolve.") === 0) {
      return this.stateRefs[key.substr(8)]();
    } else if (this.stateRefs[key]) {
      return this.stateRefs[key];
    }
  }

  /**
   * Remove resize handler.
   */
  componentWillUnmount() {
    $(window).off("resize", this.handleWindowResize);
    /**
     * The React AppTree instance gets unmounted.
     *
     * @event module:util/hooks#tree/destroy
     * @param {object} state
     * @param {object} props
     * @this module:AppTree~AppTree
     */

    hooks.call("tree/destroy", [this.state, this.props], this);
  }
  /**
   * Initiate draggable and droppable
   */


  componentDidMount() {
    // Fetch initial tree
    this.fetchTree(this.initialSelectedId);
    draggable(this);
    droppable(this);
    this.handleResize(); // If order should be enabled in list mode, then activate it now

    if (rmlOpts.others.listMode === "list" && window.location.hash === "#order") {
      this.handleOrderClick();
      window.location.hash = "";
    }
  }
  /**
   * When the component updates the droppable zone is reinitialized.
   * Also the toolbar buttons gets disabled or enabled depending on selected node.
   */


  componentDidUpdate() {
    const {
      selectedCreatableType
    } = this.state,
          selected = this.getTreeItemById();

    if (selected && selectedCreatableType !== selected.properties.type || !selected && selectedCreatableType !== undefined) {
      this._updateCreatableButtons(selected ? selected.properties.type : undefined);
    } // Enable / Disable toolbar buttons


    this._updateToolbarButtons(); // Enable locked toolbar item


    createLockedToolTipText(this);
    draggable(this);
    droppable(this);
  }
  /**
   * Return the backbone filter view for the given attachments browser.
   *
   * @returns object
   */


  getBackboneFilter() {
    const {
      attachmentsBrowser
    } = this;
    return attachmentsBrowser && attachmentsBrowser.toolbar.get("rml_folder");
  }
  /**
   * Get the selected node id.
   *
   * @returns {string|int}
   */


  getSelectedId() {
    return this.props.store.selectedId;
  }
  /**
   * Get tree item by id.
   *
   * @param {string|int} [id=Current]
   * @param {boolean} [excludeStatic=true]
   * @returns {object} Tree node
   */


  getTreeItemById(id = this.getSelectedId(), excludeStatic = true) {
    return this.props.store.getTreeItemById(id, excludeStatic);
  }
  /**
   * Update a tree item by id.
   *
   * @param {function|array} callback The callback with one argument (node draft) and should return the new node.
   * @param {string|int} [id=Current] The id which should be updated
   * @param {boolean} [setHash] If true the hash node is changed so a rerender is forced
   */


  updateTreeItemById(callback, id = this.getSelectedId(), setHash = false) {
    const node = this.props.store.getTreeItemById(id);
    node && node.setter(callback, setHash);
  }
  /**
   * Updates the create node. That's the node without id and the input field.
   *
   * @param {object} modifier The modifier object which is passed through Object.assign
   */


  async updateCreateNode(modifier) {
    // Root update
    const createRoot = this.state.createRoot;
    createRoot && this.setState({
      createRoot: immer.produce(createRoot, modifier)
    }); // Child node update

    const node = this.getTreeItemById();
    node && node.$create && this.updateTreeItemById(node => {
      const obj = { ...node.$create
      };
      modifier(obj);
      node.$create = obj;
    }, undefined, true);
  }
  /**
   * Disable the checked property for all checked nodes.
   *
   * @method
   */


  handleDestroy() {
    this.ref && ReactDOM.unmountComponentAtNode(this.ref.container.parentNode);
  }
  /**
   * Dismiss the import tax notice for a given time (transient).
   *
   * @method
   */


  /**
   * Set the attachments browser location.
   *
   * @param {int} [id=Current selected id] The id
   */
  _handleBackboneFilterSelection(id = this.getSelectedId()) {
    const attachmentsBrowser = this.attachmentsBrowser;

    if (attachmentsBrowser && id !== ID_NONE) {
      setTimeout(() => {
        const backboneFilter = this.getBackboneFilter();
        backboneFilter && backboneFilter.$el.val(id).change(); // Reset bulk select in no-modal mode

        attachmentsBrowser.$el.parents(".media-modal").length === 0 && attachmentsBrowser.controller.state().get("selection").reset(); // Check if folder needs refresh

        const {
          store
        } = this.props;

        if (store.foldersNeedsRefresh.indexOf(id) > -1) {
          store.removeFoldersNeedsRefresh(id);
          this.handleReload();
        }
      }, 0);
    }
  }
  /**
   * Update the creatable buttons regarding the selected type.
   *
   * @param {int} selectedCreatableType
   */


  _updateCreatableButtons(selectedCreatableType) {
    this.setState({
      selectedCreatableType
    });
    this.state.availableCreatables.forEach(c => this.setState({
      ["creatable_" + c]: Object.assign(this.state["creatable_" + c], {
        visible: this.state["creatable_" + c].visibleInFolderType.indexOf(selectedCreatableType) > -1
      })
    }));
  }

  _updateToolbarButtons() {
    const {
      isWPAttachmentsSortMode,
      toolbar_order,
      toolbar_rename,
      toolbar_trash,
      toolbar_details
    } = this.state,
          selected = this.getTreeItemById(),
          disableIfStatic = !selected,
          restrictions = selected && selected.properties && selected.properties.restrictions || [];
    const disableOrder = disableIfStatic || isWPAttachmentsSortMode || selected && selected.contentCustomOrder === 2 || selected && selected.orderAutomatically;
    toolbar_order.disabled !== disableOrder && this.setState({
      toolbar_order: Object.assign(toolbar_order, {
        disabled: disableOrder
      })
    });
    const disableRename = disableIfStatic || restrictions.indexOf("ren") > -1;
    toolbar_rename.disabled !== disableRename && this.setState({
      toolbar_rename: Object.assign(toolbar_rename, {
        disabled: disableRename
      })
    });
    const disableTrash = disableIfStatic || restrictions.indexOf("del") > -1;
    toolbar_trash.disabled !== disableTrash && this.setState({
      toolbar_trash: Object.assign(toolbar_trash, {
        disabled: disableTrash
      })
    });
    toolbar_details.disabled !== disableIfStatic && this.setState({
      toolbar_details: Object.assign(toolbar_details, {
        disabled: disableIfStatic
      })
    });
  }
  /**
   * Fetch folder tree.
   */


  async fetchTree(setSelectedId) {
    this.setState({
      isTreeBusy: true
    });

    try {
      const {
        slugs
      } = await this.props.store.fetchTree(setSelectedId); // Modify all available attachments browsers filter

      $(FILTER_SELECTOR).each(function () {
        const backboneFilter = $(this).data("backboneView"); // Clone to remove immutability

        backboneFilter && backboneFilter.createFilters(JSON.parse(JSON.stringify(slugs)));
      });

      this._handleBackboneFilterSelection();

      latestQueriedFolder.node = this.props.store.selected;
    } catch (e) {
      console.log(e);
    } // Modify this tree


    this.setState({
      isTreeBusy: false
    });
  }
  /**
   * Update the folder count. If you pass no argument the folder count is
   * requested from server.
   *
   * @param {object} counts Key value map of folder and count
   */


  async fetchCounts(counts) {
    return await this.props.store.fetchCounts(counts);
  }

}) || _class) || _class);
export default AppTree;